export const balanceErrorBannerStyle = {
  root: {
    background: "#fff7ed",
    border: "1px solid #fdba74",
    borderRadius: "10px",
    padding: "10px 14px",
    "--notification-color": "#f97316",
  },
};

export const channelLockBannerStyle = {
  root: {
    background: "#eff6ff",
    border: "1px solid #93c5fd",
    borderRadius: "10px",
    padding: "10px 14px",
    "--notification-color": "#3b82f6",
  },
};

export const entryLimitBannerStyle = {
  root: {
    background: "#fef2f2",
    border: "1px solid #fca5a5",
    borderRadius: "10px",
    padding: "10px 14px",
    "--notification-color": "#ef4444",
  },
};
